<template>
    <div class="identification-container">
        <Header :showCartButton="false" :showHomeButton="false" :showBackButton="selectedMethod !== null" @navigateToBackScreen="navigateToBackScreen()" class="header"></Header>
        <div class="title">
            <h2>{{ getString('identificacao') }}</h2>
        </div>
        <div class="identification-content" :class="{ 'not-identified': !!selectedMethod }">
            <div class="identification-components" v-if="selectedMethod">
                <component :is="currentComponent" :preSelectedMethod="selectedMethod" @closeModal="gotToHome($event)" @loginSuccess="loginSuccess()" @changeMethod="changeMethod()" @cancelLogin="cancelLogin($event)" />
            </div>
            <div class="identification-methods" v-else>
                <div class="identification-method" v-for="method in getMethodsVisible()" :key="method.name"
                    @click="selectMethod(method.name)" :class="{ 'selected': method.name === selectedMethod }">
                    <img :src="method.icon" :alt="method.text" class="identification-method-icon">
                    <h2>{{ method.text }}</h2>
                </div>
                <div v-if="getMethodsVisible().length === 2"></div>
                <div class="not-identified" @click="selectMethod(false)">
                    <div class="not-identified-button">
                        <h2>{{ getString('nao_quero_identificar') }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Header from '@/components/Header.vue'
import ConsumerLogin from '@/components/consumerLogin/ConsumerLogin.vue'
import Util from '@/assets/libs/util'
export default {
    name: 'Identification',
    components: {
        Header,
        ConsumerLogin
    },
    data () {
        return {
            methosdIdentification: [
                {
                    name: 'faceRecognition',
                    text: this.getString('reconhecimento_facial'),
                    icon: require('../../static/icons/faceRecognition.svg'),
                    visible: Util.getLocalConfigs('useFaceRecognition') || false
                },
                {
                    name: 'badgeNumber',
                    text: this.getString('cracha'),
                    icon: require('../../static/icons/badge.svg'),
                    visible: Util.getLocalConfigs('lockKeyboardCons')
                },
                {
                    name: 'password',
                    text: this.getString('senha_de_acesso'),
                    icon: require('../../static/icons/password.svg'),
                    visible: !Util.getLocalConfigs('lockKeyboardCons')
                }
            ],
            methodsVisible: [],
            selectedMethod: null
        }
    },
    computed: {
        currentComponent () {
            return 'ConsumerLogin'
        }
    },
    mounted () {
        let preselectedMethod = this.getMethodsVisible()
        if (preselectedMethod.length === 1) {
            this.selectedMethod = preselectedMethod[0].name
        }
    },
    methods: {
        selectMethod (method) {
            if (method === false) {
                this.$router.push({ name: 'Home' })
                return
            }
            this.selectedMethod = method
        },
        getMethodsVisible () {
            return this.methosdIdentification.filter(method => method.visible)
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        gotToHome (userVerified) {
            this.$router.push({ name: 'Home' })
        },
        changeMethod () {
            this.selectedMethod = null
        },
        loginSuccess () {
            this.$router.push({ name: 'Home' })
        },
        cancelLogin (error = false) {
            this.selectedMethod = null
            if (error) {
                return
            }
            this.$router.push({ name: 'Home' })
        },
        navigateToBackScreen () {
            this.selectedMethod = null
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.identification-container {
    display: grid;
    grid-template-areas:
        "header"
        "title"
        "content";
    grid-template-rows: 180px 120px auto;
    height: calc(100vh - 60px);
    width: 100vw;
    background-color: @white;

    .header {
        grid-area: header;
        z-index: 1;
    }
    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        grid-area: title;
        h2 {
            color: @primary-dark;
            font-size: 3rem;
            font-weight: 600;
            margin: 0;
        }
    }

    .identification-content {
        grid-area: content;
        padding: 0 50px;
        display: grid;
        height: 100%;
        box-sizing: border-box;
        .identification-components {
            height: 100%;
        }

        .identification-methods {
            display: grid;
            grid-template-rows: repeat(4, 1fr);

            .identification-method {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-evenly;
                // height: 20%;
                border: 1px solid @primary-dark;
                border-radius: 10px;
                margin: 0px 10px 20px 10px;
                background-color: @primary-color;

                .identification-method-icon {
                    width: 130px;
                    height: 130px;
                    filter: brightness(0) invert(1);
                }

                h2 {
                    color: @white;
                    font-size: 2rem;
                    font-weight: 600;
                    margin: 0;
                }
                /* &.selected {
                    background-color: @primary-color;
                    color: @white;
                    .identification-method-icon {
                        filter: brightness(0) invert(1);
                    }
                    h2 {
                        color: @white;
                    }
                } */
            }

        }

        .not-identified {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            // border: 1px solid @primary-dark;
            // border-radius: 10px;
            margin: 20px 10px;

            h2 {
                color: @primary-dark;
                font-size: 2rem;
                font-weight: 600;
                margin: 0;
            }
        }
    }
}
@media (min-width: 699px) and (max-width: 1025px) {

    .identification-container {
        grid-template-rows: 130px 100px auto;

        .title {
            h2 {
                font-size: 2.5rem;
            }
        }

        .identification-content {
            grid-area: content;
            padding: 0 40px;
            display: grid;

            .identification-methods {
                .identification-method {
                    margin: 0 5px 15px 5px;
                    .identification-method-icon {
                        width: 100px;
                        height: 100px;
                    }

                    h2 {
                        color: @white;
                        font-size: 1.8rem;
                    }
                }

            }

            .not-identified {
                margin: 0 5px 10px 5px;
                h2 {
                    font-size: 1.8rem;
                }
            }
        }
    }
}

@media (max-width: 698px) {
    .identification-container {
        grid-template-rows: 50px 72px auto;
        height: calc(100vh - 30px);

        .title {
            padding: 0 16px;
            text-align: center;

            h2 {
                font-size: 1.45rem;
                line-height: 1.2;
            }
        }

        .identification-content {
            grid-area: content;
            padding: 0 20px;

            .identification-methods {
                display: grid;
                grid-template-rows: auto;

                .identification-method {
                    border-radius: 5px;
                    margin: 0 5px 10px 5px;
                    background-color: @primary-color;

                    .identification-method-icon {
                        width: 60px;
                        height: 60px;
                    }

                    h2 {
                        color: @white;
                        font-size: 1.2rem;
                    }
                }

            }

            .not-identified {
                margin: 0px 5px 10px 5px;
                border-radius: 5px;
                h2 {
                    font-size: 1.2rem;
                }
            }
        }
    }
}

@media (orientation: landscape) and (max-width: 1025px) {
    .identification-container {
        grid-template-rows: 90px 80px auto;
        height: calc(100vh - 30px);

        .title {
            padding: 0 12px;

            h2 {
                font-size: 1.5rem;
                line-height: 1.15;
            }
        }

        .identification-content {
            padding: 0 24px;

            .identification-methods {
                display: grid;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                grid-template-rows: auto auto;
                column-gap: 10px;
                row-gap: 12px;
                align-items: stretch;

                .identification-method {
                    margin: 0;
                    border-radius: 8px;
                    padding: 0 6px 10px 6px;

                    .identification-method-icon {
                        width: 64px;
                        height: 64px;
                    }

                    h2 {
                        font-size: 1.15rem;
                        text-align: center;
                    }
                }

                .not-identified {
                    grid-column: span 3;
                    margin: 0 0 10px 0;
                }
            }

            .not-identified h2 {
                font-size: 1.15rem;
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 1026px) and (max-width: 1367px) {
    .identification-container {
        grid-template-rows: 90px 70px auto;
        height: calc(100vh - 30px);

        .title {
            h2 {
                font-size: 2rem;
            }
        }

        .identification-content {
            padding: 0 35px;

            .identification-methods {
                display: grid;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                grid-template-rows: auto auto;
                column-gap: 16px;
                row-gap: 16px;
                align-items: stretch;

                .identification-method {
                    margin: 0;
                    border-radius: 9px;
                    padding: 14px 10px;

                    .identification-method-icon {
                        width: 96px;
                        height: 96px;
                    }

                    h2 {
                        font-size: 1.65rem;
                        text-align: center;
                    }
                }

                .not-identified {
                    grid-column: span 3;
                    margin: 0 0 10px 0;
                }
            }

            .not-identified h2 {
                font-size: 1.65rem;
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 1368px) {
    .identification-container {
        grid-template-rows: 160px 96px auto;
        height: 100vh;

        .title {
            h2 {
                font-size: 2.6rem;
            }
        }

        .identification-content {
            padding: 20px 50px;

            .identification-methods {
                display: grid;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                grid-template-rows: auto auto;
                column-gap: 24px;
                row-gap: 20px;
                align-items: stretch;

                .identification-method {
                    margin: 0;
                    padding: 18px 14px;

                    .identification-method-icon {
                        width: 120px;
                        height: 120px;
                    }

                    h2 {
                        font-size: 1.9rem;
                        text-align: center;
                    }
                }

                .not-identified {
                    grid-column: span 3;
                    margin: 0;
                }
            }

            .not-identified h2 {
                font-size: 1.9rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Identification.vue